export default __webpack_public_path__ + "images/514952f3f41c52a5df1dc8bb9516fde2.png";